import { render, staticRenderFns } from "./OsDashButton.vue?vue&type=template&id=086338e1&scoped=true"
import script from "./OsDashButton.vue?vue&type=script&lang=ts"
export * from "./OsDashButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086338e1",
  null
  
)

export default component.exports